import { zExt } from "@redotech/rpc/ext";
import { z } from "zod/v4";
export const getSubmissionWorkflowStatus = {
  name: "getSubmissionWorkflowStatus" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({
    finished: z.boolean(),
    noWorkflow: z.boolean().nullish(),
  }),
};
